import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const BoxTraySleeves = () => <ProductDetailPage {...getProductPageConfig('boxTraySleeves')} />;

export default BoxTraySleeves;
